import { useCallback, useMemo, useState } from "react";

import { DrawRounded } from "@mui/icons-material";
import { isArray, isEmpty, isNil, merge, size } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RffSectionAuthorizationSignature } from "../../components/finalForm/common/CreditAuthorizationFormQuestions";
import RffForm from "../../components/finalForm/RffForm";
import Flx from "../../components/layout/Flx";
import Screen from "../../components/layout/Screen";
import TitledHeader from "../../components/layout/TitledHeader";
import { useBorrowerPortalHook } from "../../hooks/useBorrowerPortalHook";
import { pipelineSetApplicationDeals } from "../../redux/reducers/pipelineReducer";
import BorrowersSection from "./BorrowersSection";
import BorrowingEntitiesSection from "./BorrowingEntitiesSection";
import FileUploadSection from "./FileUploadSection";
import LoanDetailSection from "./LoanDetailSection";
import PropertiesSection from "./PropertiesSection";
import TitledLoanSection from "./TitledLoanSection";
import { useEndpointHook } from "../../hooks/useEndpointHook";
import { financingRequestsClear } from "../../redux/reducers/financingRequestsReducer";
import { profileClear } from "../../redux/actions/profileActions";
import SubmittedFinancingRequestsSection from "../DashboardHomeScreen/SubmittedFinancingRequestsSection";
import UnderwritingRequirementsAlert from "../../components/alerts/UnderwritingRequirementsAlert";
import ScreenContent from "../../components/layout/ScreenContent";

const lsPrefix = "NewFinancingRequestScreenSaves";

const FinancingRequestsScreen = () => {
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);

  const quickSave = localStorage.getItem(`${lsPrefix}-quickSave`);

  const [quickSaveData, setQuickSaveData] = useState(
    quickSave ? JSON.parse(quickSave) : null,
  );

  const [formData, setFormData] = useState(quickSaveData);
  const { loading, createNewFinancingRequest } = useEndpointHook();
  // const { loading, createNewApplicationDeal } = useBorrowerPortalHook();
  // const { loading, createLoan, createLoanWithFileUploads } =
  //   useUnderwritingHook();

  const navigate = useNavigate();

  const handleCreateLoanSuccess = () => {
    resetFormData();
    // getFinancingRequests();
    navigate("/");
  };

  const onFormSubmit = (formData) => {
    let data = { ...formData };
    let loanName = formData?.loanName;
    if (isNil(loanName) && isArray(data?.subjectProperties)) {
      const propertyName = data?.subjectProperties[0]?.address?.fullAddress;
      if (propertyName) {
        loanName = propertyName;
      }
    }

    data.loanName = loanName;

    // // ssss
    // if (isArray(data?.uploadMetadata) && size(data?.uploadMetadata) >= 1) {
    //   // createLoanWithFileUploads({
    //   //   data: data,
    //   //   onSuccessFn: (d) => {
    //   //     localStorage.removeItem(`${lsPrefix}-quickSave`);
    //   //     handleCreateLoanSuccess();
    //   //   },
    //   // });
    //   createNewFinancingRequest({
    //     data: data,
    //     onSuccessFn: (d) => {
    //       dispatch(financingRequestsClear());
    //       dispatch(profileClear());
    //       handleCreateLoanSuccess();
    //     },
    //   });
    // } else {
    //   createNewFinancingRequest({
    //     data: data,
    //     onSuccessFn: (d) => {
    //       dispatch(financingRequestsClear());
    //       dispatch(profileClear());
    //       handleCreateLoanSuccess();
    //     },
    //   });
    // }
    // ssss
    createNewFinancingRequest({
      data: data,
      onSuccessFn: (d) => {
        dispatch(financingRequestsClear());
        dispatch(profileClear());
        handleCreateLoanSuccess();
      },
    });
  };

  const defaultValues = useMemo(() => {
    return {
      borrowers: [{}],
      subjectProperties: [{}],
      // loanProductType: "Fix and Flip",
      // loanPurpose: "Purchase",
    };
  }, []);

  const resetFormData = useCallback(() => {
    setFormData(defaultValues);
    setQuickSaveData(null);
  }, [defaultValues]);

  const initialState = useMemo(() => {
    if (!isEmpty(formData)) {
      return formData;
    }

    const initialBorrowerData = {
      dateOfBirth: profile.dateOfBirth,
      emailAddress: profile.emailAddress,
      firstName: profile.firstName,
      lastName: profile.lastName,
      maritalStatus: profile.maritalStatus,
      phone: profile.phone,
      borrowerHasSSN: isNil(profile.borrowerSSN) ? false : true,
      citizenshipStatus: profile.citizenshipStatus,
      primaryAddress: profile?.primaryAddress,
      borrowerSSN: profile?.borrowerSSN,
    };

    const initialBorrower = {
      borrowers: [initialBorrowerData],
    };

    let combinedValues = merge(defaultValues, initialBorrower);
    return combinedValues;
  }, [formData, profile, defaultValues]);

  return (
    <Screen
      sx={{
        position: "absolute",
        left: 0,
        width: "100%",
        backgroundColor: "#f5f8fa",
        height: "100%",
      }}
    >
      <TitledHeader
        title={"My Financing Requests"}
        // description="Please provide the necessary details to create a new loan."
      />
      <ScreenContent
        maxWidth={"lg"}
        sx={{
          width: "100%",
          pb: 14,
          pt: 2,
          // px: isMobile ? 0 : 5,
          margin: "0px auto",
        }}
      >
        <UnderwritingRequirementsAlert />
        <SubmittedFinancingRequestsSection mt={2.5} />
      </ScreenContent>
    </Screen>
  );
};

export default FinancingRequestsScreen;
